import { render, staticRenderFns } from "./FundSortModal.vue?vue&type=template&id=5b62606f&"
import script from "./FundSortModal.vue?vue&type=script&lang=js&"
export * from "./FundSortModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports